<template>
  <div>
    <app-bar :showtab="false">
      <template v-slot:title>密码重置</template>
    </app-bar>
    <v-card>
      <v-card-title> 密码重置 </v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-text-field
            :rules="[(v) => !!v || '邮箱不能为空']"
            v-model="email"
            color="link"
            label="邮箱"
          ></v-text-field>
          <Vaptcha
            ref="captcha"
            v-model="vaptcha"
            scene="1"
            style="height: 46px"
            type="click"
          ></Vaptcha>
          <v-btn
            @click="sendCode"
            class="mt-4"
            block
            color="link"
            dark
            elevation="0"
            :loading="email_code_loading"
            >发送验证码</v-btn
          >
          <v-text-field
            :rules="[(v) => !!v || '验证码不能为空']"
            v-model="email_code"
            color="link"
            label="验证码"
            type="number"
          ></v-text-field>
          <v-text-field
            v-model="passwd"
            color="link"
            label="新密码"
            :rules="[(v) => !!v || '密码不能为空']"
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn :loading="loading" @click="resetPwd" text color="link" dark>
          修改密码
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import AppBar from "@/components/common/AppBar/AppBar";
import login from "../../networker/login";

export default {
  components: {
    AppBar,
  },
  data() {
    return {
      email: "",
      email_code: "",
      email_code_loading: false,
      passwd: "",
      captcha: {},
      loading: false,
      vaptcha: null,
    };
  },
  methods: {
    async sendCode() {
      if (!this.email) {
        this.$emit("snackbar", {
          text: "邮箱不能为空",
          color: "error",
        });
        return;
      }
      if (!this.validate()) {
        this.$emit("snackbar", {
          text: "请先进行人机验证",
          color: "error",
        });
        return;
      }
      this.email_code_loading = true;
      let res = await login.validateMail(this.email, this.captcha, "重置密码");
      this.email_code_loading = false;
      if (res.data.success) {
        this.$emit("snackbar", {
          text: res.data.message,
          color: "green",
        });
      }
      this.$refs.captcha.vaptcha.reset();
      (this.captcha = {}), (this.vaptcha = null);
    },
    async resetPwd() {
      if (!this.$refs.form.validate()) {
        return;
      }
      if (!this.validate()) {
        this.$emit("snackbar", {
          text: "请先进行人机验证",
          color: "error",
        });
        return;
      }
      this.loading = true;
      let res = await login.resetPasswd(
        this.email,
        this.email_code,
        this.passwd,
        this.captcha
      );
      this.loading = false;

      this.$emit("snackbar", {
        text: res.data.message,
        color: "green",
      });

      this.$refs.captcha.vaptcha.reset();
    },
    validate() {
      let c = this.handle_captcha(null, 1);
      if (c) {
        this.captcha = c.captcha;
        return true;
      }
      return false;
      // return this.$refs.from.validate() && c;
    },
    handle_captcha(obj = null, scene = 0) {
      let api_server;
      let token;
      if (obj === null) {
        if (this.vaptcha == null) {
          return null;
        }
        api_server = this.$refs.captcha.vaptcha.config.api_server;
        token = this.vaptcha.token;
      } else {
        api_server = obj.config.api_server;
        token = obj.token;
      }
      let api_server_array = api_server.split(".");
      if (api_server_array[1] !== "vaptcha") {
        return null;
      }
      return {
        captcha: {
          server:this.$refs.captcha.vaptcha.config.server,
          token: token,
          scene: scene,
        },
      };
    },
  },
};
</script>